import { getData, addEditData } from '../generic';
import { cAPI } from '../../../utils/cAPI';

export const getLanguages = () => dispatch => getData(dispatch, cAPI.APGetLanguages, null, 'languages');
export const updateLanguagesStatus = (formData) => dispatch => addEditData(dispatch, cAPI.APUpdateLanguages, formData, 'languages');